module.exports = __webpack_public_path__ + "fonts/Montserrat-ThinItalic.f402a29.ttf";